import React, { Component } from 'react';

import TissueFilter from "./tissueFilter";
import GeneticFilter from "./geneticFilter";
import DatasetFilter from "./datasetFilter";
import ModelTypeFilter from "./modelTypeFilter";
import TissueStatusFilter from "./tissueStatusFilter";
import CancerTypeFilter from "./cancerTypeFilter";
import MSIStatusFilter from "./MSIFilter";
import CommercialFilter from "./commercialFilter";
import CpvFilter from "./cpvFilter";
import MolecularSubtypeFilter from "./MolecularSubtypeFilter";


class Filters extends Component {

    render() {

        const {
            registerRequest,
            registerResponse,
            unregisterRequest,
            unregisterResponse,
            requestAggregation
        } = this.props;


        return (

            <div className="filter-wrapper">

                <TissueFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <CancerTypeFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <ModelTypeFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <MSIStatusFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <TissueStatusFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <MolecularSubtypeFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <GeneticFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <CpvFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <DatasetFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />


                <CommercialFilter
                    registerRequest={registerRequest}
                    registerResponse={registerResponse}
                    unregisterRequest={unregisterRequest}
                    unregisterResponse={unregisterResponse}
                    requestAggregation={requestAggregation}
                />

            </div>
        );
    }
}


export default Filters;